import {TextStyle} from './textStyle';

export class Text {
  id?: number = 0;
  text?: string[];
  style?: TextStyle;
  fontFamily?: string;
  fontStyle?: string;
  textTransform?: string;
  fontWeight?: string;
  color?: string;
  transfer?: boolean = false;
  noWarp?: boolean = false;

  constructor(value?: Text) {
    if(value?.id != undefined) this.id = value?.id;
    this.text = value?.text;
    this.style = value?.style;
    this.fontFamily = value?.fontFamily;
    this.fontStyle = value?.fontStyle;
    this.textTransform = value?.textTransform;
    this.fontWeight = value?.fontWeight;
    this.color = value?.color;
    this.transfer = value?.transfer ?? false;
    this.noWarp = value?.noWarp ?? false;
  }
}
